import React from 'react';

import { usePeoPayrollProviderEmployersByIdQuery } from 'src/api';
import { usePeoPayrollProviderParamId } from 'src/hooks/peoPayrollProvider';

import { PeoPayrollProviderLiveStatusForm } from './PeoPayrollProviderLiveStatusForm';
import { prepareInitialDataForLiveStatus } from './utils';

export const PeoPayrollProviderLiveStatusWrapper = () => {
  const peoPayrollProviderId = usePeoPayrollProviderParamId();
  const { data, loading } = usePeoPayrollProviderEmployersByIdQuery({
    variables: {
      id: peoPayrollProviderId || '',
    },
    skip: !peoPayrollProviderId,
  });

  const initialValues = React.useMemo(() => {
    return prepareInitialDataForLiveStatus(data?.peoPayrollProvider ?? null);
  }, [data?.peoPayrollProvider]);

  return (
    <PeoPayrollProviderLiveStatusForm
      peoPayrollProviderId={peoPayrollProviderId || ''}
      initialValues={initialValues}
      loading={loading}
    />
  );
};
